<i class="fa fa-list-ul"></i>

<style>
    .fa {
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        margin-right: 10px;
    }

    .fa-list-ul:before {
        content: "\f0ca";
        box-sizing: border-box;
    }
</style>
